var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('header-portfolio'),_c('work-section'),_c('about-section'),_c('contact-section'),_c('footer-section')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }